module.exports = __webpack_public_path__ + "static/media/zoom-lg.2ac2bd5c.png";